module.exports = __webpack_public_path__ + "static/img/icon_code_dy.ed665e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/icon_code_dy.png
// module id = x8+l
// module chunks = 49